// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scrollbar-width: thin;
  scrollbar-color: #576775 #373c42;
  overflow-y: scroll;
  overflow-x: hidden;
}

#root {
  background-color: #212529 !important;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.submit-buttons button {
  padding: 0.5em 2rem;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 700;
  /* font-style: italic; */
  text-transform: uppercase;
  transition: background-color 250ms;
  height: unset;
  max-height: unset;
  border: none;
  border-radius: 0;
}
.submit-buttons button.btn-primary {
  background-color: #ff2c00 !important;
}

ul {
  list-style: none;
  padding-left: 0 !important;
  margin: 0;
  background-color: #2f353b;
  border-radius: 10px;
  border-bottom: 1px solid #2f353b;
}

li {
  background-color: #2f353b;
  border-bottom: 0.5px solid #41484f;
  padding: 4px;
  padding-left: 10px;
}
li:last-child {
  border-bottom: none;
}

li:hover {
  border-top: 1px solid #4c535b;
  border-bottom: 1px solid #4c535b;
  background-color: #282c31;
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.9rem !important;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: #272c31 !important;
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
  border: none !important;
}

.tableFixHead {
  overflow: auto;
  height: 77vh;
}
.tableFixHead.small {
  height: 30vh;
}

.table {
  background: transparent !important;
  border-spacing: 0 0.4em !important;
  border-collapse: separate;
}
.table thead {
  margin-bottom: 10px !important;
}
.table thead tr:first-child th:first-child {
  border-top-left-radius: 5px !important;
}
.table thead tr:first-child th:last-child {
  border-top-right-radius: 5px !important;
}
.table thead tr:last-child th:first-child {
  border-bottom-left-radius: 5px !important;
}
.table thead tr:last-child th:last-child {
  border-bottom-right-radius: 5px !important;
}
.table thead th {
  background-color: white !important;
  color: black !important;
  border: 0 !important;
  margin-bottom: 5px;
  position: sticky;
  top: 0;
  z-index: 1;
  text-transform: uppercase;
  padding: 0.4rem 0.9rem !important;
  font-size: 0.8rem;
}
.table tbody tr:nth-child(odd) td {
  background-color: #2f353b !important;
}

.overlay {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
}

.inspect-server {
  padding: 2rem 3rem;
  border-radius: 5px;
}
.inspect-server button {
  margin-left: 0.5rem;
}

ul {
  margin-top: 10px;
  list-style: none;
  padding: 0;
}
ul li span {
  width: 10rem;
  display: inline-block;
  font-weight: 700;
  text-align: right;
  margin-right: 0.5rem;
  overflow: hidden;
  white-space: nowrap;
}

.nav-pills .nav-link {
  opacity: 0.5;
  padding: 0.5rem 0;
  margin-right: 1rem;
  font-size: 1.2rem;
}
.nav-pills .nav-link:hover {
  opacity: 1;
  color: white !important;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  opacity: 1;
  background: transparent !important;
}

.nav-pills .nav-link.active::after {
  height: 2px;
  width: 100%;
  content: "";
  display: block;
  background: #ff2c00;
}

.form-control {
  color: #ffffff !important;
  background-color: #40454b !important;
  border: var(--bs-border-width) solid #72787f !important;
}

.modal-body .form-control {
  color: inherit !important;
  background-color: inherit !important;
  border-color: hsl(0, 0%, 80%) !important;
}

.sub-items label {
  margin-top: 20px;
}

.page-content {
  min-height: calc(100vh - 57px) !important;
}

.content-management .edit-content {
  padding-bottom: 100px;
}

.form-check-input {
  margin-left: 0;
}

form label {
  margin: 0px 0 10px;
}
form input {
  margin-bottom: 20px;
}

.accordion-item {
  background-color: #212529 !important;
  border: 1px solid #373c42 !important;
  border-radius: 0 !important;
  color: white !important;
}
.accordion-item .accordion-body {
  padding: 2rem;
  max-height: 52vh;
  overflow: auto;
  border-radius: 0 !important;
}

.accordion-button:not(.collapsed) {
  color: #ffffff !important;
  background-color: #ff2c00;
  box-shadow: none !important;
}
.accordion-button:not(.collapsed) span {
  background: rgb(255, 133, 133);
  border-radius: 20px;
  color: #221d1d;
  padding: 3px 8px;
  margin-left: 0.5rem;
  font-weight: 500;
}

.accordion-button {
  background-color: #454d54 !important;
  color: #ffffff !important;
  font-weight: 500;
  text-transform: uppercase;
  border-radius: 0 !important;
}
.accordion-button span {
  background: rgb(45, 50, 54);
  border-radius: 20px;
  color: white;
  padding: 3px 8px;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  justify-content: center;
}

.languages-dropdown > .dropdown-menu {
  height: 25vh;
  max-height: 25vh;
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;AAFF;;AAKA;EACE,+EAAA;AAFF;;AAOE;EAKE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,kCAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AARJ;AAPI;EACE,oCAAA;AASN;;AAUA;EACE,gBAAA;EACA,0BAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;AAPF;;AAUA;EACE,yBAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,6BAAA;EACA,gCAAA;EACA,yBAAA;AARF;;AAYA;EACE,iCAAA;EACA,qFAAA;EACA,oCAAA;EACA,2CAAA;EACA,2GAAA;EACA,uBAAA;AATF;;AAaA;EACE,cAAA;EAAgB,YAAA;AATlB;AAWE;EACE,YAAA;AATJ;;AAaA;EACE,kCAAA;EACA,kCAAA;EACA,yBAAA;AAVF;AAYE;EACE,8BAAA;AAVJ;AAWI;EAAgC,sCAAA;AARpC;AASI;EAA+B,uCAAA;AANnC;AAQI;EAA+B,yCAAA;AALnC;AAMI;EAA8B,0CAAA;AAHlC;AAKI;EACE,kCAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,yBAAA;EACA,iCAAA;EACA,iBAAA;AAHN;AASM;EACE,oCAAA;AAPR;;AAaA;EACE,8BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAVF;;AAaA;EACE,kBAAA;EACA,kBAAA;AAVF;AAYE;EACE,mBAAA;AAVJ;;AAcA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AAXF;AAcI;EACE,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAZN;;AAiBA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAdF;AAgBE;EACE,UAAA;EACA,uBAAA;AAdJ;;AAkBA;EACE,UAAA;EACA,kCAAA;AAfF;;AAkBA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,oCAAA;EACA,uDAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,oCAAA;EACA,wCAAA;AAfF;;AAmBE;EACE,gBAAA;AAhBJ;;AAoBA;EACE,yCAAA;AAjBF;;AAuBE;EACE,qBAAA;AApBJ;;AAwBA;EACE,cAAA;AArBF;;AAyBE;EACE,kBAAA;AAtBJ;AAyBE;EACE,mBAAA;AAvBJ;;AA2BA;EACE,oCAAA;EACA,oCAAA;EACA,2BAAA;EACA,uBAAA;AAxBF;AA0BE;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;AAxBJ;;AA4BA;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;AAzBF;AA2BE;EACE,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAzBJ;;AA6BA;EACE,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;AA1BF;AA4BE;EACE,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AA1BJ;;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AA3BF","sourcesContent":["// bright white scrollbar next to dark theme caused eye strain\nhtml {\n  scrollbar-width: thin;\n  scrollbar-color: #576775 #373c42;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n#root {\n  background-color: #212529 !important;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.submit-buttons {\n  button {\n    &.btn-primary {\n      background-color: #ff2c00 !important;\n    }\n    \n    padding: 0.5em 2rem;\n    text-align: center;\n    font-size: 1.3rem;\n    font-weight: 700;\n    /* font-style: italic; */\n    text-transform: uppercase;\n    -webkit-transition: background-color 250ms;\n    transition: background-color 250ms;\n    height: unset;\n    max-height: unset;\n    border: none;\n    border-radius: 0;\n  } \n}\n\n\nul {\n  list-style: none;\n  padding-left: 0 !important;\n  margin: 0;\n  background-color: #2f353b;\n  border-radius: 10px;\n  border-bottom: 1px solid #2f353b;\n}\n\nli {\n  background-color: #2f353b;\n  border-bottom: 0.5px solid #41484f;\n  padding: 4px;\n  padding-left: 10px;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\nli:hover {\n  border-top: 1px solid #4c535b;\n  border-bottom: 1px solid #4c535b;\n  background-color: #282c31;\n}\n\n\n.table>:not(caption)>*>* {\n  padding: 0.5rem 0.9rem !important;\n  color: var(--bs-table-color-state,var(--bs-table-color-type,var(--bs-table-color)));\n  background-color: #272c31 !important;\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state,var(--bs-table-bg-type,var(--bs-table-accent-bg)));\n  border: none !important;\n  \n}\n\n.tableFixHead {\n  overflow: auto; height: 77vh;\n\n  &.small {\n    height: 30vh;\n  }\n}\n\n.table {\n  background: transparent !important;\n  border-spacing: 0 .4em !important;\n  border-collapse:separate; \n\n  thead {\n    margin-bottom: 10px !important; \n    tr:first-child th:first-child { border-top-left-radius: 5px !important; }\n    tr:first-child th:last-child { border-top-right-radius: 5px !important; }\n\n    tr:last-child th:first-child { border-bottom-left-radius: 5px !important; }\n    tr:last-child th:last-child { border-bottom-right-radius: 5px !important; }\n\n    th {\n      background-color: white !important;\n      color: black !important;\n      border: 0 !important;\n      margin-bottom: 5px;\n      position: sticky; \n      top: 0;\n      z-index: 1;\n      text-transform: uppercase;\n      padding: 0.4rem 0.9rem !important;\n      font-size: 0.8rem;\n    }\n  }\n\n  tbody {\n    tr:nth-child(odd) {\n      td {\n        background-color: #2f353b !important;\n      }\n    }\n  }\n}\n\n.overlay {\n  background: rgba(0,0,0,0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 998;\n}\n\n.inspect-server {\n  padding: 2rem 3rem;\n  border-radius: 5px;\n  \n  button {\n    margin-left: 0.5rem;\n  }\n}\n\nul {\n  margin-top: 10px;\n  list-style: none;\n  padding: 0;\n\n  li {\n    span {\n      width: 10rem;\n      display: inline-block;\n      font-weight: 700;\n      text-align: right;\n      margin-right: 0.5rem;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n  }\n}\n\n.nav-pills .nav-link {\n  opacity: 0.5;\n  padding: 0.5rem 0;\n  margin-right: 1rem;\n  font-size: 1.2rem;\n\n  &:hover {\n    opacity: 1;\n    color: white !important;\n  }\n}\n\n.nav-pills .nav-link.active, .nav-pills .show>.nav-link {\n  opacity: 1;\n  background:transparent !important;\n}\n\n.nav-pills .nav-link.active::after {\n  height: 2px;\n  width: 100%;\n  content: '';\n  display: block;\n  background: #ff2c00;\n}\n\n.form-control {\n  color: #ffffff !important;\n  background-color: #40454b !important;\n  border: var(--bs-border-width) solid #72787f !important;\n}\n\n.modal-body .form-control {\n  color: inherit !important; \n  background-color: inherit !important; \n  border-color: hsl(0, 0%, 80%) !important; \n}\n\n.sub-items {\n  label {\n    margin-top: 20px;\n  }\n}\n\n.page-content {\n  min-height: calc(100vh - 57px) !important;\n}\n\n.content-management {\n  // height: calc(100vh - 57px) !important;\n\n  .edit-content {\n    padding-bottom: 100px;\n  }\n}\n\n.form-check-input {\n  margin-left: 0;\n}\n\nform {\n  label {\n    margin: 0px 0 10px;\n  }\n\n  input {\n    margin-bottom: 20px;\n  }\n}\n\n.accordion-item {\n  background-color: #212529 !important;\n  border: 1px solid #373c42 !important;\n  border-radius: 0 !important;\n  color: white !important;\n\n  .accordion-body {\n    padding: 2rem;\n    max-height: 52vh;\n    overflow: auto;\n    border-radius: 0 !important;\n  }\n}\n\n.accordion-button:not(.collapsed) {\n  color: #ffffff !important;\n  background-color: #ff2c00;\n  box-shadow: none !important;\n\n  span {\n    background: rgb(255 133 133);\n    border-radius: 20px;\n    color: #221d1d;\n    padding: 3px 8px;\n    margin-left: 0.5rem;\n    font-weight: 500;\n  }\n}\n\n.accordion-button {\n  background-color: #454d54 !important;\n  color: #ffffff !important;\n  font-weight: 500;\n  text-transform: uppercase;\n  border-radius: 0 !important;\n\n  span {\n    background: rgb(45 50 54);\n    border-radius: 20px;\n    color: white;\n    padding: 3px 8px;\n    margin-left: 0.5rem;\n    display: flex;\n    align-items: center;\n    font-size: 0.9rem;\n    justify-content: center;\n  }\n}\n\n.languages-dropdown > .dropdown-menu {\n  height: 25vh;\n  max-height: 25vh;\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
